import { LengthTokenValue } from 'designSystem/types';
import * as S from './styles';

interface SpacingTokenPreviewProps {
	value: LengthTokenValue;
}

export const SpacingTokenPreview = ({ value }: SpacingTokenPreviewProps) => {
	const spacing = value.px || value.numericValue * 16;
	return (
		<S.PreviewContainer>
			<S.SpacingLayout>
				<S.SpacingBoxLeft spacing={spacing} />
				<S.FixedBox />
				<S.SpacingBoxRight spacing={spacing} />
			</S.SpacingLayout>
		</S.PreviewContainer>
	);
};
